module.exports = __webpack_public_path__ + "resource/img/rank-banner.50a38f01.png";